import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { matterApi, type MatterSummary, matterDisplayName } from '../../api';
import Select from '../../components/common/Select';

export default function MattersList() {
  const [matters, setMatters] = useState<MatterSummary[]>([]);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState<'open' | 'finalised' | 'archived' | ''>('open');

  const load = () => matterApi.list({ q, status: status || undefined }).then((r) => setMatters(r.matters));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  return (
    <div className="stack">
      <div className="row">
        <h1 className="grow">Matters</h1>
        <Link to="/matters/new"><button className="primary">New matter</button></Link>
      </div>
      <div className="row">
        <input className="grow" placeholder="Search by reference, name or case number…" value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && load()} />
        <Select
          value={status}
          onChange={(v) => setStatus(v as typeof status)}
          style={{ width: 180 }}
          options={[
            { value: '', label: 'All statuses' },
            { value: 'open', label: 'Open' },
            { value: 'finalised', label: 'Finalised' },
            { value: 'archived', label: 'Archived' },
          ]}
        />
        <button onClick={load}>Refresh</button>
      </div>
      <div className="card">
        {matters.length === 0 ? <p className="muted">No matters found.</p> : (
          <table>
            <thead><tr><th>Reference</th><th>Name</th><th>Case no.</th><th>Status</th><th>Opened</th></tr></thead>
            <tbody>
              {matters.map((m) => (
                <tr key={m.ROWID}>
                  <td><Link to={`/matters/${m.ROWID}`}>{m.reference}</Link></td>
                  <td>{matterDisplayName(m)}</td>
                  <td>{m.case_number || '—'}</td>
                  <td><span className="pill">{m.status}</span></td>
                  <td>{m.opened_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
